import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { AppModal } from "../../_CORE/APP/Templates/_UI/Modal/_index";
import { MetricCard, MetricGrid } from "../../_CORE/APP/Templates/_UI/Metrics/_index";
import "./_Styles/StatisticsModal.css";

export const StatisticsModal = ({
    isOpen,
    onClose,
    title = "Estadísticas",
    description = "Resumen general de la sección.",
    metrics = [],
    children = null,
    routeKey = "stats",
}) => {
    const [searchParams, setSearchParams] = useSearchParams();
    const routeOpen = searchParams.get(routeKey) === "1";
    const visible = !!isOpen || routeOpen;

    useEffect(() => {
        if (!isOpen || routeOpen) return;
        const next = new URLSearchParams(searchParams);
        next.set(routeKey, "1");
        setSearchParams(next, { replace: false });
    }, [isOpen]); // eslint-disable-line react-hooks/exhaustive-deps

    const handleClose = () => {
        const next = new URLSearchParams(searchParams);
        next.delete(routeKey);
        setSearchParams(next, { replace: true });
        onClose?.();
    };

    return (
        <AppModal isOpen={visible} onClose={handleClose} size="lg" title={title} description={description}
            className="LStudio__statistics_modal">
            <div className="LStudio__statistics_modal_content">
                <MetricGrid columns="auto">
                    {metrics.map((metric, index) => (
                        <MetricCard key={metric.key || metric.label || index}
                            label={metric.label}
                            value={metric.value}
                            unit={metric.unit || null}
                            icon={metric.icon || null}
                            tone={metric.tone || "neutral"}
                            footer={metric.footer || null}
                            isLoading={!!metric.isLoading} />
                    ))}
                </MetricGrid>
                {children}
            </div>
        </AppModal>
    );
};
